import step1 from './steps/step1.json';
import step10 from './steps/step10.json';
import step11 from './steps/step11.json';
import step2 from './steps/step2.json';
import step3 from './steps/step3.json';
import step4 from './steps/step4.json';
import step5 from './steps/step5.json';
import step6 from './steps/step6.json';
import step7 from './steps/step7.json';
import step8 from './steps/step8.json';
import step9 from './steps/step9.json';

const getRiskyData = () => ({
  name: 'What will you risk?',
  url: 'risky',
  mainColor: '#F8645B',
  steps: [
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
    step7,
    step8,
    step9,
    step10,
    step11
  ],
  thumbnail: '/journey%20to%20success/00%20dashboard/thumbnails/entrepreneurial-mindset/what-will-you-risk.svg',
  summary: 'Define your risk profile to discover your risk tolerance vs. risk capacity.'
});

export {
  getRiskyData
};
